import convertCoordsTimeline from "./convert-coords-timeline";
import convertSingleTimeline from "./convert-single-timeline";
import prepareInitialSteps from "./prepare-initial-steps";

/**
 * Convert string into timeline format
 * @param {Array<String>} array
 * @returns {Array<String>}
 */
const prepareString = (array) => {
  const results = /** @type {Array<String>} */ ([]);

  for (const item of array) {
    /** Check for offset timeline */
    const isOffset = /\[\[|%_\[|s_\[/.test(item);

    if (isOffset) {
      /** Process the first (initial) step of the offset timeline */
      prepareInitialSteps(item, results);
    } else {
      /** Single property */
      convertSingleTimeline(item, results);
    }
  }

  return results;
};

export default prepareString;
